import './style.scss';
import { lbbConfig } from './config';
// Lightbox Block
document.addEventListener('DOMContentLoaded', () => {
    const allBlockDirectory = document.querySelectorAll('.wp-block-lbb-lightbox');
    allBlockDirectory.forEach(directory => {
        const attributes = JSON.parse(directory.dataset.attributes);
        const { cId } = attributes;
        lbbConfig(cId);
        directory?.removeAttribute('data-attributes');
    });
});